<template>
    <div id="homeBox">
        <div style="display: flex;justify-content: space-between;height: 40px">
            <div style="display:flex;align-items: center;margin-right: 20px">
<!--                <div>类型搜索:</div>-->
<!--                <div style="margin: 0 5px">-->
<!--                    <el-select size="mini" v-model="type">-->
<!--                        <el-option-->
<!--                        v-for="item in typeList"-->
<!--                        :key="item.id"-->
<!--                        :label="item.name"-->
<!--                        :value="item.id"-->
<!--                        >-->

<!--                        </el-option>-->
<!--                    </el-select>-->
<!--                </div>-->
<!--                <span class="titlew" >选择时间:</span>-->
<!--                <el-date-picker-->
<!--                        size="mini" style="width:200px"-->
<!--                        v-model="startTime"-->
<!--                        type="datetime"-->
<!--                        :picker-options="dateLimit"-->
<!--                        placeholder="开始时间"-->
<!--                        value-format="yyyy-MM-dd"-->
<!--                        @blur="startChange"-->
<!--                        clearable-->
<!--                >-->
<!--                </el-date-picker>-->
<!--                <span class="titlew" > 至 </span>-->
<!--                <el-date-picker size="mini" style="width: 200px; margin-right:15px; "-->
<!--                                v-model="endTime"-->
<!--                                type="datetime"-->
<!--                                :picker-options="dateLimit"-->
<!--                                clearable-->
<!--                                placeholder="结束时间"-->
<!--                                value-format="yyyy-MM-dd"-->
<!--                                @blur="endChange"-->
<!--                >-->
<!--                </el-date-picker>-->
                <div>
                    <el-input
                            size="mini"
                            class="input"
                            placeholder="请输入搜索内容"
                            v-model="search"
                            clearable>
                    </el-input>
                </div>
                <el-button style="margin-left: 10px" class="mrl15 " icon="el-icon-search" circle  @click="searchall" size="mini"></el-button>
            </div>
        </div>


        <el-table
                ref="deliverlight"
                :height="tableHeight"
                highlight-current-row
                size="mini"
                :data="tableData"
                border
                style="width: 100%">
            <el-table-column
                    type="index"
                    label="序号"
                    show-overflow-tooltip>
            </el-table-column>
            <!--            <el-table-column-->
            <!--                    prop="code"-->
            <!--                    label="订单编号"-->
            <!--                    show-overflow-tooltip>-->
            <!--            </el-table-column>-->
<!--            <el-table-column-->
<!--                    prop="code"-->
<!--                    label="编号"-->
<!--                    show-overflow-tooltip>-->
<!--            </el-table-column>-->
            <el-table-column
                    prop="name"
                    label="用户名"
                    show-overflow-tooltip>
            </el-table-column>
<!--            <el-table-column-->
<!--                    prop="typeName"-->
<!--                    label="充值类型"-->
<!--                    show-overflow-tooltip>-->
<!--            </el-table-column>-->
            <el-table-column
                    prop="balance"
                    label="金额"
                    show-overflow-tooltip>
            </el-table-column>
<!--            <el-table-column-->
<!--                    prop="createTime"-->
<!--                    label="录入时间"-->
<!--                    show-overflow-tooltip>-->
<!--            </el-table-column>-->
            <el-table-column
                    label="操作"
                    show-overflow-tooltip>
                <template slot-scope="scope">
                    <el-button type="text" size="mini" @click="seebalance(scope.row)">余额明细查看</el-button>

                </template>
            </el-table-column>
        </el-table>
        <el-dialog
                :close-on-click-modal="false"

                :title="title"
                :visible.sync="detaildialog"
                width="50%"
                v-if="detaildialog"
        >
            <account-detail :editData="editData" @closedialog="closedialog" ></account-detail>
        </el-dialog>
        <!--        分页器-->
        <div class="block">
            <div class="pages">
                <div class="choosepage flexother mrt20 fl" style="display: flex;justify-content: space-between">
                    <el-pagination
                            small

                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="this.currentPage"
                            :page-sizes="[10, 50, 100, 400]"
                            :page-size="this.pageSize"
                            layout="total,sizes"
                            :total="this.total"
                    >
                    </el-pagination>
                    <el-pagination
                            small
                            :pager-count="5"
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="this.currentPage"
                            :page-size="this.pageSize"
                            layout="prev, pager, next, jumper"
                            :total="this.total">
                    </el-pagination>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import {mapActions} from "vuex";
    import {baseerp,baseApp,baseVersion} from "@/utils/baseUrl";
    import accountDetail from "./component/accountDetail";

    import * as API from "./api";
    export default{
        name:'accountManage',
        components:{
            accountDetail
        },
        data(){
            return{
                dateLimit: {
                    disabledDate: (time) => {
                        return time.getTime() > new Date().getTime()//禁用当前日期之后的日期
                    }
                },
                startTime:'',
                endTime:"",
                typeList:[
                    {
                        id:1,
                        name:'充值(餐补)'
                    },{
                        id:2,
                        name:'充值(现金)'
                    },{
                        id:3,
                        name:'充值(转帐)'
                    },{
                        id:4,
                        name:'扣款(消费)'
                    },{
                        id:5,
                        name:'退单(订单-用户)'
                    },{
                        id:6,
                        name:'退单(订单-后台)'
                    },{
                        id:7,
                        name:'销户(退钱)'
                    },
                ],
                type:'',
                date:'',
                diatitle:'',
                checkdialogVisible:false,
                loading:false,
                delDialogVisible:false,
                tableHeight:'auto',
                pageSize:10,
                currentPage:1,
                search:"",
                tableData:[],
                detaildialog:false,
                total:0,
                editData:{},
                title:'',
                mid:''
            }
        },

        watch: {
            '$root.workSize':{
                handler(n,o) {
                    // console.log(n,12312312)
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },
        created(){
            this.$nextTick(()=>{
                this.onResize();
            })
        },
        mounted(){
            this.getList()
        },

        methods:{
            startChange(){
                if(this.endTime!=''){
                    if(this.endTime<this.startTime){
                        this.startTime=''
                        this.$message.error('请选择小于或等于结束时间的值')
                    }
                }
            },
            endChange(){
                if(!this.startTime && this.endTime){
                    this.endTime=''
                    this.$message.error('请先选择开始时间')
                }
                if(this.endTime&&this.endTime<this.startTime){
                    this.endTime=''
                    this.$message.error('请选择大于或等于开始时间的值')
                }
            },
            seebalance(e){
                this.title='用户余额变动明细'
                this.editData=e
                this.detaildialog=true
            },
            searchall(){
                this.currentPage=1
                this.tableData=[]
                this.getList()
            },
            savesuccess(){
                this.currentPage=1
                this.tableData=[]
                this.getList()
                this.delDialogVisible=false
            },
            guanbi(){
                this.checkdialogVisible=false
                this.currentPage=1
                this.tableData=[]
                this.getList()
            },

            chongzhi(){
                this.editData={
                    uName:'',
                    id:0,
                    moneyTotal:0,
                    note:'',
                    type:''
                }
                this.delDialogVisible=true
            },
            closedialog(){
                this.delDialogVisible=false
                this.detaildialog=false


            },

            ...mapActions(["getCurrentMenuId"]),
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-100

                // console.log(n.h)
                // $('.contentRight').width($("#homeBox").width() - $('.contentLeft').width() - 5 );
                // this.$refs.spread_Edit.onResize();
            },

            //分页
            handleSizeChange(val) {
                this.pageSize = val;    //动态改变
                this.getList()
            },
            handleCurrentChange(val) {
                this.currentPage = val;    //动态改变
                this.getList()
            },
            async getList(val){
                let param = {
                    pageSize:this.pageSize,
                    currentPage:this.currentPage,
                    // id:'',
                    // startDate:this.startTime,
                    // endDate:this.endTime,
                    // date:this.data,
                    search:this.search,
                    // type:this.type
                };
                let res = await API.getList(param);
                if (res.code == 1) {
                    this.tableData=res.data
                    this.total=res.total
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
        },
    }

</script>
<style lang="scss" scoped>

    .flexcenter{
        min-width: 39.286rem;
        width: 100%;
        height: 2.857rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 0.857rem;
    }
    .uploadfile1{
        position: absolute;
        opacity: 0;
        top: -3px;
        left: 6px;
        width: 100px;
        height: 80px;
    }
    /deep/{
        .el-table--enable-row-transition{
            /*min-width:610px !important;*/
        }
        .el-button--text{
            padding: 0 !important;
            margin-left: 0 !important;
            margin-right: 10px;
        }
        .el-tabs__content{
            /*height: 90% !important;*/
            overflow: visible !important;
            height:calc(100% - 0.357rem) !important;
        }
    }
    /deep/.is-leaf .cell .el-checkbox__input{
        display: none;
    }
    .m{
        padding-top: 1.429rem;
    }
    .flexother {
        display: flex;
        /*flex-flow: wrap;*/
        justify-content: space-between;
        align-items: center;
    }
    .fl{
        float: left;
        .el-button--primary{
            color: #efd773;
            background-color:white;
            border: 0;
            text-align: center;
            padding: 0;
            height: 2rem;
            width: 3.286rem;
            margin:0.857rem 0 0 0.714rem;
        }
    }

    .fr{
        float:right;
    }

    .cl{
        clear: both;
    }
    .input{
        width: 14.286rem;
    }
    /*.mrt20{*/
    /*    margin-top: 1.429rem;*/
    /*}*/
    .mrl20{
        margin-left: 1.429rem;
    }
    .mrb20{
        margin-right: 1.429rem;
    }
    .mrr20{
        margin-right: 1.429rem;
    }

    .chooseheader{
        width:100%;
    }

    .choosepage{
        /*min-width: 41.571rem;*/
        width:90%
    }
    .left{
        width: 17.857rem;
    }
</style>